export default __webpack_public_path__ + "static/media/Timeout_Red.b37dd2ca.svg";